export const iconFontAwesomeFoodBeverageWheatAwnCircleExclamation = (
	<i className="fa-solid fa-wheat-awn-circle-exclamation"></i>
);
